import React, { createContext, useContext, useEffect, useState, ReactNode } from "react";

type FontSize = "default"|"small" | "medium" | "large";

interface FontSizeContextType {
    fontSize: FontSize;
    applyFontSize: (size: FontSize) => void;
}

const FontSizeContext = createContext<FontSizeContextType | undefined>(undefined);

const FONT_SIZE_KEY = "app-font-size"; // 👈 key dùng trong sessionStorage

export const FontSizeProvider = ({ children }: { children: ReactNode }) => {
    const getInitialFontSize = (): FontSize => {
        const stored = sessionStorage.getItem(FONT_SIZE_KEY);
        if (stored === "small" || stored === "medium" || stored === "large") {
            return stored;
        }
        return "small";
    };

    const [fontSize, setFontSize] = useState<FontSize>(getInitialFontSize);

    const applyFontSize = (size: FontSize) => {
        const root = document.body;
        // root.classList.remove("text-sm", "text-base", "text-lg");
        root.classList.remove("font-scale-sm", "font-scale-md", "font-scale-lg");
        if (size === "default") {
            root.classList.remove("font-overridden");
            document.documentElement.style.removeProperty("font-size");
            sessionStorage.removeItem("app-font-size");
        } else {
            root.classList.add("font-overridden");
            // const px = size === "small" ? 0.5 : size === "large" ? 1.125 : 0.85;
            // document.documentElement.style.fontSize = `${px}rem`;
            // sessionStorage.setItem("app-font-size", size);
            const classMap = {
                small: "font-scale-sm",
                medium: "font-scale-md",
                large: "font-scale-lg",
            };
            root.classList.add(classMap[size]);
            sessionStorage.setItem("app-font-size", size);
        }
        setFontSize(size);
    };

    // 👇 Áp dụng font-size khi load lần đầu
    useEffect(() => {
        applyFontSize(fontSize);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <FontSizeContext.Provider value={{ fontSize, applyFontSize }}>
            {children}
        </FontSizeContext.Provider>
    );
};

export const useFontSize = () => {
    const context = useContext(FontSizeContext);
    if (!context) throw new Error("useFontSize must be used within FontSizeProvider");
    return context;
};
